import React from 'react';
import './Background.scss';

const Background = () => {
  return (
    <div className="backgroundBody">
      <div className="dot1" />
      <div className="dot2" />
      <div className="dot3" />
    </div>
  );
};
export default Background;
